import baseTypography from '../fingo/typography';
import { applyItauFontFamilies } from './typography-utils';
import { ITAU_FONT_TEXT, ITAU_BASE_FONT_SIZE } from './fonts';

const itauTypography = applyItauFontFamilies({
  ...baseTypography,
  fontFamily: ITAU_FONT_TEXT,
  fontSize: ITAU_BASE_FONT_SIZE,
  htmlFontSize: ITAU_BASE_FONT_SIZE,
});

export default itauTypography;
